/* Rubio color gallery: species switcher, near-viewport image loading, color panel, analytics. No dependencies. */
(() => {
  const root = document.querySelector('[data-rubio-colors]');
  if (!root) return;
  const family = root.dataset.family;
  const prefix = root.dataset.prefix;
  const handles = root.dataset.handles.split('|');
  const sizes = root.dataset.sizes.split('|');
  const sampleHandles = root.dataset.sampleHandles.split('|');
  const cur = root.dataset.cur || '$';
  const WIDTHS = [120, 160, 240];
  const PANEL_WIDTHS = [480, 720, 1000]; // panel photo: loads only on click; masters are 1000-1200 px
  const SIZES_ATTR = '(min-width: 1068px) 140px, (min-width: 750px) 22vw, 31vw';
  const dl = (event, p) => { (window.dataLayer = window.dataLayer || []).push({ event, family, ...p }); };
  const btns = [...root.querySelectorAll('.rubio-species__btn')];
  // Species: from the buttons, or (single-species families, no buttons) from data-keys / data-labels on the root.
  const keys = btns.length ? btns.map(b => b.dataset.species) : (root.dataset.keys || '').split('|');
  const labels = btns.length ? btns.map(b => b.dataset.label) : (root.dataset.labels || '').split('|');
  const label = root.querySelector('[data-species-current]');
  const note = root.querySelector('[data-species-note]');
  const legNote = root.querySelector('[data-legacy-note]');
  const tiles = [...root.querySelectorAll('.rubio-tile')];
  let sel = 0; // selected species index; 0 = default (White Oak solid)

  // species index -> file slug for this tile, or null when the color is not photographed on it
  const ALL = root.dataset.all;
  // species index -> this color's photo on that species, or null (no photo: shown as unavailable, never substituted)
  const fileFor = (tile, i) => {
    const sp = (tile.dataset.sp === 'a' ? ALL : tile.dataset.sp).split(',');
    return sp.includes(String(i)) ? `${prefix}${tile.dataset.s}-${keys[i]}.jpg` : null;
  };
  const url = (file, w) => `/cdn/shop/files/${file}?width=${w}`; // Shopify CDN: resized + WebP/AVIF by Accept header
  const srcset = file => WIDTHS.map(w => `${url(file, w)} ${w}w`).join(', ');
  const altFor = (tile, i) => `${tile.querySelector('.rubio-tile__name').textContent} Rubio Monocoat ${family} on ${labels[i].replace(/^(.*) \((solid|veneer)\)$/, '$2 $1').toLowerCase()}`;

  // White Oak is photographed three ways: current colors on "White Oak Solid" and "White Oak Veneer", legacy colors on
  // "White Oak" (Rubio does not say solid or veneer). Within White Oak only, a missing photo falls back to another White Oak
  // photo, and the tile is labeled with the wood actually pictured. Any other species is never substituted.
  const WO = [2, 0, 1].map(k => keys.indexOf(['white-oak-solid', 'white-oak-veneer', 'white-oak'][k])).filter(k => k >= 0);
  const target = tile => {
    const own = fileFor(tile, sel);
    if (own || !WO.includes(sel)) return { file: own, i: sel, sub: false };
    for (const k of WO) { const f = k !== sel && fileFor(tile, k); if (f) return { file: f, i: k, sub: true }; }
    return { file: null, i: sel, sub: false };
  };

  function imgOf(tile) {
    let img = tile.querySelector('img.rubio-tile__img');
    if (!img) { // tile rendered without a photo for the default species: create the element on demand
      img = document.createElement('img'); img.className = 'rubio-tile__img'; img.width = 240; img.height = 240; img.decoding = 'async';
      img.setAttribute('data-lazy', ''); tile.querySelector('.rubio-tile__media').prepend(img);
    }
    return img;
  }
  function naOf(tile) {
    let na = tile.querySelector('.rubio-tile__na');
    if (!na) { na = document.createElement('span'); na.className = 'rubio-tile__na'; na.textContent = 'Image unavailable for this species'; tile.querySelector('.rubio-tile__media').append(na); }
    return na;
  }
  function onOf(tile, t) { // "Shown on <wood>" label, only when the picture is another White Oak than the one selected
    let on = tile.querySelector('.rubio-tile__on');
    if (!t.sub) { if (on) on.hidden = true; return; }
    if (!on) { on = document.createElement('span'); on.className = 'rubio-tile__on'; tile.querySelector('.rubio-tile__media').append(on); }
    on.textContent = `Shown on ${labels[t.i]}`; on.hidden = false;
  }
  // Rubio's per-species guidance (DuroGrit): data-nr = species indexes "not recommended for technical reasons",
  // data-rn = "recommended for a natural look". Shown as a label on the tile for the selected species.
  const inList = (v, i) => !!v && v.split(',').includes(String(i));
  const recFor = tile => inList(tile.dataset.nr, sel) ? 'nr' : inList(tile.dataset.rn, sel) ? 'rn' : '';
  const REC_TEXT = { nr: 'Not recommended for technical reasons', rn: 'Recommended for a natural look' };
  function recOf(tile) {
    if (!tile.dataset.nr && !tile.dataset.rn) return;
    let el = tile.querySelector('.rubio-tile__rec');
    const r = recFor(tile);
    if (!r) { if (el) el.hidden = true; return; }
    if (!el) { el = document.createElement('span'); tile.querySelector('.rubio-tile__media').append(el); }
    el.className = `rubio-tile__rec rubio-tile__rec--${r}`;
    el.textContent = r === 'nr' ? 'Not recommended' : 'Natural look';
    el.title = `${REC_TEXT[r]} on ${labels[sel]}`;
    el.hidden = false;
  }
  function paint(tile) {
    const t = target(tile);
    onOf(tile, t);
    recOf(tile);
    if (!t.file) { // no photo on this species: hide any picture and say so
      const img = tile.querySelector('img.rubio-tile__img');
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('src'); delete img.dataset.file; img.setAttribute('data-lazy', ''); img.hidden = true; }
      naOf(tile).hidden = false;
      return;
    }
    const na = tile.querySelector('.rubio-tile__na'); if (na) na.hidden = true;
    const img = imgOf(tile); img.hidden = false;
    if (img.dataset.file === t.file) return; // already showing it: no request
    img.dataset.file = t.file;
    img.sizes = SIZES_ATTR;
    img.srcset = srcset(t.file);
    img.src = url(t.file, 240);
    img.alt = altFor(tile, t.i);
    img.removeAttribute('data-lazy');
  }

  // Server-rendered first-row images: remember their file so an unchanged species costs nothing.
  tiles.forEach(tile => { const img = tile.querySelector('img.rubio-tile__img:not([data-lazy])'); if (img) img.dataset.file = fileFor(tile, 0); });

  // Load only tiles near the viewport; re-evaluated on every species change.
  const near = new Set();
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { near.add(e.target); paint(e.target); } else near.delete(e.target);
    });
  }, { rootMargin: '150px 0px' }) : null;
  tiles.forEach(t => (io ? io.observe(t) : paint(t)));

  function applySpecies(i, fromUser) {
    sel = i;
    btns.forEach((b, j) => b.setAttribute('aria-pressed', String(j === i)));
    if (label) label.textContent = labels[i];
    let missingCur = 0, missingLeg = 0, subCur = null, subLeg = null;
    tiles.forEach(tile => {
      const t = target(tile);
      if (!t.file) { if (tile.dataset.g === 'l') missingLeg++; else missingCur++; }
      if (t.sub) { if (tile.dataset.g === 'l') subLeg = labels[t.i]; else subCur = labels[t.i]; }
      onOf(tile, t);
      recOf(tile);
      if (!io || near.has(tile) || !t.file) paint(tile);  // visible now, or unavailable: update immediately (no download)
      else {                                              // off-screen: forget the old picture, load when scrolled to
        const na = tile.querySelector('.rubio-tile__na'); if (na) na.hidden = true;
        const img = tile.querySelector('img.rubio-tile__img');
        if (img && img.dataset.file !== t.file) {
          img.removeAttribute('srcset'); img.removeAttribute('src'); delete img.dataset.file; img.setAttribute('data-lazy', ''); img.hidden = false;
        }
      }
    });
    if (note) {
      note.hidden = !missingCur && !subCur;
      note.textContent = missingCur ? `${missingCur} current colors have no photo on ${labels[i]}.`
        : subCur ? `Rubio photographs current colors on ${subCur}; each photo is labeled.` : '';
    }
    if (legNote) {
      const on = labels.filter((_, k) => tiles.some(t => t.dataset.g === 'l' && fileFor(t, k)));
      legNote.textContent = missingLeg ? `No legacy color is photographed on ${labels[i]}. Choose ${on.join(', ')} to see them.`
        : subLeg ? `Rubio photographed legacy colors on ${subLeg} (not specified as solid or veneer); each photo is labeled.` : '';
    }
    if (fromUser) {
      history.replaceState(null, '', i === 0 ? location.pathname + location.search : `#species=${keys[i]}`);
      dl('rubio_color_species', { species: keys[i] });
    }
  }
  btns.forEach((b, i) => b.addEventListener('click', () => applySpecies(i, true)));
  applySpecies(0, false);
  const h = (location.hash.match(/species=([a-z-]+)/) || [])[1];
  if (h && keys.includes(h)) applySpecies(keys.indexOf(h), false);

  // Panel
  const dialog = root.querySelector('[data-rubio-dialog]');
  const fanTpl = root.querySelector('template[data-fan-deck]');
  let opener = null;
  const link = (href, cls, text) => { const a = document.createElement('a'); a.href = href; a.className = cls; a.textContent = text; return a; };
  function remember(tile, id, size) {
    try { sessionStorage.setItem('rubio_color_discovery', JSON.stringify({ family, color: tile.dataset.s, variant_id: id, size, species: keys[sel], t: Date.now() })); } catch (_) {}
  }

  tiles.forEach(tile => tile.addEventListener('click', e => {
    if (!dialog || typeof dialog.showModal !== 'function' || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // plain link fallback
    e.preventDefault();
    opener = tile;
    const name = tile.querySelector('.rubio-tile__name').textContent;
    const t = target(tile);
    const dImg = dialog.querySelector('[data-d-img]');
    const dNa = dialog.querySelector('[data-d-na]');
    if (t.file) { dImg.sizes = '(min-width: 1068px) 600px, (min-width: 750px) 60vw, calc(100vw - 32px)'; dImg.srcset = PANEL_WIDTHS.map(w => `${url(t.file, w)} ${w}w`).join(', '); dImg.src = url(t.file, 720); dImg.alt = altFor(tile, t.i); dImg.hidden = false; dNa.hidden = true; }
    else { dImg.removeAttribute('srcset'); dImg.removeAttribute('src'); dImg.hidden = true; dNa.hidden = false; }
    dialog.querySelector('[data-d-title]').textContent = name;
    const kind = tile.dataset.gl || (tile.dataset.g === 'l' ? 'Legacy color' : 'Current color');
    const r = recFor(tile);
    dialog.querySelector('[data-d-meta]').textContent = `${kind} · ${t.file ? 'shown on' : 'no photo on'} ${labels[t.i]}` +
      (r ? ` · ${REC_TEXT[r].toLowerCase()} on ${labels[sel]}` : '');
    const buy = dialog.querySelector('[data-d-buy]'); buy.replaceChildren();
    tile.dataset.v.split('|').forEach((v, k) => {
      if (!v) return;
      const [id, price, avail] = v.split('~');
      const a = link(`/products/${handles[k]}?variant=${id}`, k === 0 ? 'button small' : 'button small alt', `${sizes[k]} · ${cur}${price}${avail ? '' : ' (sold out)'}`);
      a.addEventListener('click', () => { remember(tile, id, sizes[k]); dl('rubio_color_shop_click', { color: name, variant_id: id, size: sizes[k] }); });
      buy.append(a);
    });
    const sample = dialog.querySelector('[data-d-sample]'); sample.replaceChildren();
    if (tile.dataset.x) {
      const [id, price, hi] = tile.dataset.x.split('~');
      const a = link(`/products/${sampleHandles[+hi]}?variant=${id}`, 'button small alt', `Order ${/^[aeiou]/i.test(name) ? 'an' : 'a'} ${name} sample · ${cur}${price}`);
      a.addEventListener('click', () => { remember(tile, id, 'sample'); dl('rubio_color_sample_click', { color: name, variant_id: id }); });
      sample.append(a);
    } else if (fanTpl) sample.append(fanTpl.content.cloneNode(true));
    dialog.showModal();
    buy.querySelector('a')?.focus();
    dl('rubio_color_open', { color: name, status: tile.dataset.g === 'l' ? 'legacy' : 'current', species: keys[sel] });
  }));
  dialog?.addEventListener('close', () => opener?.focus());
  dialog?.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });

  const legacy = root.querySelector('[data-legacy]');
  legacy?.addEventListener('toggle', () => { if (legacy.open) dl('rubio_color_legacy_open', {}); });
  dl('rubio_color_page_view', { page_type: 'family' });
})();
